import React, { forwardRef, useEffect } from "react";
import { Link } from "react-router-dom";

import logoSvg from "../../../assets/images/logo-sm.svg";

import LightDark from "../LightDark/LightDark";
import ProfileMenu from "../ProfilMenu";
import paths from "../../route/paths";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { webViewSelector } from "../../actions/LayoutMode.actions";
import { postMessageLogin } from "../../internals/asd";
import { isLoggedInSelector } from "../../actions/Authentication.actions";
import { customerListSelector } from "../../actions/CustomerList.actions";
import { getItem } from "../../hooks/useCookie";
import { useCustomerListMutation } from "../../../modules/Customer/Customer.actions";

type HeaderProps = {
  children?: React.ReactNode;
  setSidebarIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  sidebarIsOpen: boolean;
  isMobile: boolean;
};

const Header = forwardRef(
  ({ isMobile, setSidebarIsOpen, sidebarIsOpen }: HeaderProps, ref: any) => {
    const isWebView = useRecoilValue(webViewSelector);
    const isLoggedIn = useRecoilValue(isLoggedInSelector);
    const token = getItem("token");

    const setCustomerList = useSetRecoilState(customerListSelector);

    const { data, mutate } = useCustomerListMutation();

    useEffect(() => {
      const body = document.body;
      if (sidebarIsOpen) {
        body.classList.add("sidebar-enable");
        document.body.setAttribute("data-sidebar-size", "lg");
      } else {
        body.classList.remove("sidebar-enable");
        !isMobile && document.body.setAttribute("data-sidebar-size", "sm");
      }
    }, [sidebarIsOpen]);

    const tToggle = () => {
      if (sidebarIsOpen) {
        setSidebarIsOpen(!sidebarIsOpen);
        // body.classList.add('sidebar-enable')
        // !isMobile && document.body.setAttribute('data-sidebar-size', 'sm')
      } else {
        setSidebarIsOpen(!sidebarIsOpen);
      }
    };

    useEffect(() => {
      isWebView &&
        postMessageLogin(
          JSON.stringify({
            id: isLoggedIn.profile?.id,
            token: token,
            is_followed: isLoggedIn.profile?.can_follow,
          })
        );
    }, [isWebView]);

    useEffect(() => {
      mutate({});
    }, []);

    useEffect(() => {
      data && setCustomerList(data);
    }, [data]);

    return (
      <React.Fragment>
        <header id="page-topbar">
          <div className="navbar-header">
            <div className="d-flex">
              <div className="navbar-brand-box">
                <Link to={paths.DASHBOARD} className="logo logo-dark">
                  <span className="logo-sm">
                    <img src={logoSvg} alt="" height="24" />
                  </span>
                  <span className="logo-lg">
                    <img src={logoSvg} alt="" height="24" />{" "}
                    <span className="logo-txt">Ezrak</span>
                  </span>
                </Link>

                <Link to="/dashboard" className="logo logo-light">
                  <span className="logo-sm">
                    <img src={logoSvg} alt="" height="24" />
                  </span>
                  <span className="logo-lg">
                    <img src={logoSvg} alt="" height="24" />{" "}
                    <span className="logo-txt">Ezrak</span>
                  </span>
                </Link>
              </div>

              <button
                ref={ref}
                onClick={() => {
                  tToggle();
                }}
                type="button"
                className="btn btn-sm px-3 font-size-16 header-item"
                id="vertical-menu-btn"
              >
                <i className="fa fa-fw fa-bars"></i>
              </button>
            </div>
            <div className="d-flex">
              <LightDark />

              {/* <NotificationDropdown /> */}

              <ProfileMenu />
            </div>
          </div>
        </header>
      </React.Fragment>
    );
  }
);

export default Header;
